import React, { useEffect } from "react";
import { onAlignRight } from "./commands";
import { S_ALIGN_RIGHT } from "./shortcuts";

import Icon from "./Icon";
import b from "./images/align-right-b.png";
import w from "./images/align-right-w.png";
import { CommandPropsWithShortcut } from "./types";

export default function AlignRight({
    enabled,
    enableDarkTheme,
    shortcut,
}: CommandPropsWithShortcut) {
    useEffect(() => {
        if (S_ALIGN_RIGHT === shortcut) {
            onAlignRight();
        }
    }, [shortcut]);

    return (
        <Icon
            src={enableDarkTheme ? b : w}
            onClick={enabled ? onAlignRight : undefined}
        />
    );
}
